jQuery(document).ready(function($) {
  'use strict';

  function floatLabel(control) {
    var container;

    container = control.closest('.ipo-mdc-form__field-container');
    container.find('.mdc-floating-label').addClass('mdc-floating-label--float-above');
  }

  $('[data-inputmask]').each(function() {
    var inputMask = $(this).data('inputmask');

    switch (inputMask) {
      case 'date':
        IMask(
          this,
          {
            mask: 'd-m-j',
            lazy: false,
            autofix: true,
            blocks: {
              d: {mask: '00', placeholderChar: 'd'},
              m: {mask: '00', placeholderChar: 'm'},
              j: {mask: '0000', placeholderChar: 'j'}
            }
          }
        );
        floatLabel($(this));
        break;
      case 'zipcode':
        IMask(
          this,
          {
            mask: '0000 aa',
            lazy: false
          }
        );
        floatLabel($(this));
        break;
      case 'first-upper':
        IMask(this, {
          mask: /^[A-Za-z\u0410-\u044F\u0401\u0451\u00C0-\u00FF\u00B5].*$/,
          commit: function(value, masked) {
            masked._value = value.charAt(0).toUpperCase() + value.slice(1);
          }
        });
        break;
      default:
        break;
    }
  });
});
